import { useRouter } from 'next/router'

export function useVariantFromRouter(): string {
  const { query } = useRouter()
  return (query.v as string) ?? ''
}
